import { Container, Row, Col, Text } from '@qonsoll/react-design'
import { OfferSimpleView } from '../../../Offer/components'
import { useGetMockupOffer } from '../../hooks'
import PropTypes from 'prop-types'
import { Spinner } from 'components'
import { useTranslations } from 'contexts/Translation'

export default function MockupOffer(props) {
  const { mockup } = props

  // [ADDITIONAL_HOOKS]
  const [offer, loading] = useGetMockupOffer(mockup)
  const { t } = useTranslations()

  return (
    <Container>
      <Row noGutters>
        <Col>
          {loading ? (
            <Spinner flex={1} />
          ) : offer ? (
            <OfferSimpleView {...props} offer={offer} />
          ) : (
            <Text type="secondary" variant="overline">
              {t('No offers have been added yet')}
            </Text>
          )}
        </Col>
      </Row>
    </Container>
  )
}

MockupOffer.propTypes = {
  mockup: PropTypes.object.isRequired
}
